module.exports = __webpack_public_path__ + "static/media/menuitem1.25f85520.png";